<div class="container-fluid ">
  <div class="row p-2">
    <div class="col-12 text-center h5 text-white mb-3">
      <img src="https://indianabgc.blob.core.windows.net/public/white-logo.png" height="40" alt="Logo" />
      Boys & Girls Clubs
    </div>
  </div>
  <router-outlet></router-outlet>
</div>
<bgcs-environment-footer></bgcs-environment-footer>